// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StreamForm__container-a28de7 {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.StreamForm__content-ee8135 {
  flex: 1;
  padding: 24px;
  overflow: auto;
  color: var(--base-110);
}

.StreamForm__image-uploader-e3afb3 {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
}

.StreamForm__avatar-bda585 {
  margin-inline-end: 16px;
}

.StreamForm__gap-d425aa {
  margin-bottom: 16px;
}

.StreamForm__title-ae214e {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
}

.StreamForm__description-fbc626 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin: 4px 0 24px 0;
}

.StreamForm__image-bf853b {
  width: 160px;
  min-height: 90px;
  max-height: 160px;
  background-color: var(--base-20);
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  margin-inline-end: 16px;
}

.StreamForm__icon-e6381a {
  width: 56px;
  height: 56px;
}

.StreamForm__preview-b65e6e {
  width: 100%;
  height: 100%;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/CreateStreamPopup/StreamForm/StreamForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,oBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  flex: 1;\n  padding: 24px;\n  overflow: auto;\n  color: var(--base-110);\n}\n\n.image-uploader {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 24px;\n}\n\n.avatar {\n  margin-inline-end: 16px;\n}\n\n.gap {\n  margin-bottom: 16px;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n}\n\n.description {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin: 4px 0 24px 0;\n}\n\n.image {\n  width: 160px;\n  min-height: 90px;\n  max-height: 160px;\n  background-color: var(--base-20);\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: center;\n  align-items: center;\n  margin-inline-end: 16px;\n}\n\n.icon {\n  width: 56px;\n  height: 56px;\n}\n\n.preview {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StreamForm__container-a28de7`,
	"content": `StreamForm__content-ee8135`,
	"image-uploader": `StreamForm__image-uploader-e3afb3`,
	"imageUploader": `StreamForm__image-uploader-e3afb3`,
	"avatar": `StreamForm__avatar-bda585`,
	"gap": `StreamForm__gap-d425aa`,
	"title": `StreamForm__title-ae214e`,
	"description": `StreamForm__description-fbc626`,
	"image": `StreamForm__image-bf853b`,
	"icon": `StreamForm__icon-e6381a`,
	"preview": `StreamForm__preview-b65e6e`
};
module.exports = ___CSS_LOADER_EXPORT___;
